
import mainSlider from '../pages/main_slider.f7.html';
import mobileVerification from '../pages/mobile_verification.f7.html';

import HomePage from '../pages/home.f7.html';
import leftPanel from '../pages/left-panel.f7.html';
import AboutPage from '../pages/about_us.f7.html';
import FormPage from '../pages/form.f7.html';
import DoctorsDepFilter from '../pages/doctors_list.f7.html';
import DoctorsHosFilter from '../pages/doctors_list_hospital.f7.html';
import booking from '../pages/booking_form.f7.html';
import sign_up from '../pages/sign_up.f7.html';
import changePassword from '../pages/changePassword.f7.html';
//import sign_in from '../pages/sign_in.f7.html';
//import otp_varification from '../pages/otp_varification.f7.html';
import paymentSuccess from '../pages/paymentSuccess.f7.html';
import edit_profile from '../pages/edit_profile.f7.html';
import appointment from '../pages/appointment.f7.html';
import appointmentDetails from '../pages/appointmentDetails.f7.html';
import searchDoctor from '../pages/doctors_search_list.f7.html';
import universalSearch from '../pages/search.f7.html';
import coupon from '../pages/coupon.f7.html';
import applyCoupon from '../pages/apply_coupon.f7.html';
import refer from '../pages/refer.f7.html';
import support from '../pages/support.f7.html';
import query from '../pages/query.f7.html';
import terms from '../pages/tems_of_use.f7.html';

import terms1 from '../pages/tems_of_use_1.f7.html';
import terms2 from '../pages/tems_of_use_2.f7.html';

import doctor_profile from '../pages/doctor_profile.f7.html';
import notification from '../pages/notification.f7.html';
//import edit_profile from '../pages/edit_profile.f7.html';

import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

//--------- v4 ---------------
import subscrition from '../pages/booking_subscrition.f7.html';
import subscrition_paynow from '../pages/subscrition_details_paynow.f7.html';
import subscrition_details from '../pages/SubscriptionDetails.f7.html';

// New pages
import allCategories from '../pages/all_categories.f7.html';
import allSpecialities from '../pages/all_specialities.f7.html';
import allHospitals from '../pages/all_hospitals.f7.html';
import pathlab from '../pages/pathlab.f7.html';
import pathlabTests from '../pages/pathlab_tests.f7.html';
import bloodBank from '../pages/blood_bank.f7.html';
import ipd from '../pages/ipd.f7.html';
import patients from '../pages/patients.f7.html';
import labBookings from '../pages/lab_bookings.f7.html';
import offersPage from '../pages/offers.f7.html';
import feedbackPage from '../pages/feedback.f7.html';

// Helper: load the first page of doctors for the /searchDoctor/[:type] route.
// type: '1' = partner-only, '0' = non-partner, undefined/'' = all
function loadInitialDoctors(app, type, resolve) {
    app.preloader.show();
    var city = localStorage.getItem('city') || '';
    var base = 'doctors?city=' + encodeURIComponent(city);
    if (type === '1' || type === '0') {
        base += '&isPartnerDoctor=' + type;
    }
    var url = app.data.remoteUrl + base + '&page=1&per_page=10';
    app.request.json(url, function (data) {
        app.preloader.hide();
        var list = (data && data.data) ? data.data : (data || []);
        var meta = (data && data.meta) ? data.meta : { has_more: false, current_page: 1, total: list.length };
        resolve(
            { component: searchDoctor },
            {
                context: {
                    assetsUrl: app.data.assetsUrl,
                    data: list,
                    partnerType: type || '',
                    hasMore: !!meta.has_more,
                    currentPage: meta.current_page || 1,
                    perPage: meta.per_page || 10,
                    total: meta.total || list.length,
                    listEndpoint: base,
                }
            }
        );
    }, function () {
        app.preloader.hide();
        resolve(
            { component: searchDoctor },
            {
                context: {
                    assetsUrl: app.data.assetsUrl,
                    data: [],
                    partnerType: type || '',
                    hasMore: false,
                    currentPage: 1,
                    perPage: 10,
                    total: 0,
                    listEndpoint: base,
                }
            }
        );
    });
}

var routes = [

    {
        path: '/left-panel/',
        panel: {
            component: leftPanel,
        },
    },

    {
        path: '/home/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;

//            document.addEventListener("deviceready", function () {
            var saveToken = localStorage.getItem("token");
            var oneSignal = localStorage.getItem("playerID");
            
//            console.log("token - " + saveToken);
            if (saveToken == null || saveToken == '') {
                localStorage.setItem("token", "");
                resolve({
                    component: mainSlider,
                });
            } else {
                // Serve fresh cached home payload instantly when available
                // (60s TTL). Bypasses the network and preloader entirely.
                var cached = app.methods.getCachedHome && app.methods.getCachedHome();
                if (cached) {
                    resolve({ component: HomePage }, { context: cached });
                    return;
                }

                app.preloader.show();
                var city = localStorage.getItem('city');
                var url = app.data.remoteUrl + 'home?city=' + city;
                // Set auth header for authenticated request
                app.methods.authHeader();
                app.request({
                    url: url,
                    method: 'GET',
                    dataType: 'json',
                    data: {one_signal_id: oneSignal},
                    statusCode: {
                        404: function (xhr) {
                            alert('page not found');
                        },
                        401: function (xhr) {
                            localStorage.setItem("token", "");
                            resolve({
                                component: mobileVerification,
                            });
                        },
                    },
                    success: function (data) {
                        app.preloader.hide();
                        if (data.status) {
                            // API returns data inside 'data' object with plural field names
                            var apiData = data.data || data;

                            // Limit departments to 6 items (2 rows of 3)
                            var departmentLimited = apiData.departments ? apiData.departments.slice(0, 6) : [];
                            // Limit hospitals to 6 items (2 rows of 3)
                            var hospitalLimited = apiData.hospitals ? apiData.hospitals.slice(0, 6) : [];

                            var homeContext = {
                                assetsUrl: app.data.assetsUrl,
                                package: apiData.package,
                                department: apiData.departments,
                                departmentLimited: departmentLimited,
                                hospital: apiData.hospitals,
                                hospitalLimited: hospitalLimited,
                                slider: apiData.sliders,
                                city: apiData.city,
                                module: apiData.modules,
                                adSliders: apiData.ad_sliders || [],
                                testimonials: apiData.testimonials || [],
                                achievements: apiData.achievements || { users: 0, doctors: 0, hospitals: 0, patients_served: 0 },
                                vision: apiData.vision || { title: '', body: '' },
                                enquiry: apiData.enquiry || { phone: '', email: '', address: '' },
                                upcomingAppointment: apiData.upcoming_appointment || null,
                                recentDoctors: apiData.recent_doctors || [],
                                footerText: apiData.footer_text || 'Powered by mDOC'
                            };

                            if (app.methods.setCachedHome) {
                                app.methods.setCachedHome(homeContext);
                            }

                            resolve(
                                    {
                                        component: HomePage,
                                    },
                                    {
                                        context: homeContext
                                    }
                                )
                        } else {
                            localStorage.setItem("token", "");
                            resolve({
                                component: mobileVerification,
                            });
                        }

                    },
                    complete: function () {
                        app.preloader.hide();
                    },
                    error: function (xhr) {
                        app.preloader.hide();
                        app.methods.requestError(xhr);
                    },
                    beforeSend: function () {
                        app.preloader.show();
                    },
                });
            }
//            }, false);
        },
        on: {
            pageAfterIn(e, page) {
                page.router.clearPreviousHistory();
            },
        },
    },
//
//    {
//        path: '/',
//        async: function (routeTo, routeFrom, resolve, reject) {
//            // Router instance
//            var router = this;
//            // App instance
//            var app = router.app;
//            // Show Preloader
//            app.preloader.show();
//            var saveToken = localStorage.getItem("token");
//            var url = app.data.remoteUrl + 'home/' + saveToken + '/';
//            app.request.json(url, function (data) {
//                console.log(data);
//                app.preloader.hide();
//                if (data.status) {
//                    resolve(
//                            {
//                                component: HomePage,
//                            },
//                            {
//                                context: {
//                                    department: data.department,
//                                    hospital: data.hospital,
//                                    slider: data.slider,
//                                    city: data.city
//                                }
//                            }
//                    );
//                } else {
//                    localStorage.setItem("token", "");
//                    resolve({
//                        component: sign_in,
//                    });
//                }
//
//            });
//        },
//        on: {
//            pageAfterIn(e, page) {
//                page.router.clearPreviousHistory();
//            },
//        },
//    },
//
    {
        path: '/feedback/',
        component: feedbackPage,
    },
    {
        path: '/offers/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var app = this.app;
            app.preloader.show();
            app.methods.authHeader();
            app.request({
                url: app.data.remoteUrl + 'offers',
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    app.preloader.hide();
                    var offers = (data && data.data) ? data.data : [];
                    resolve(
                        { component: offersPage },
                        { context: { offers: offers } }
                    );
                },
                error: function () {
                    app.preloader.hide();
                    resolve({ component: offersPage }, { context: { offers: [] } });
                },
            });
        },
    },
    {
        path: '/sign_up/:mobile/',
        component: sign_up,
    },
    {
        path: '/changePassword/:mobile/',
        component: changePassword,
    },
    {
        path: '/mobileVerification/',
        component: mobileVerification,
    },
    {
        path: '/sign_in/',
        component: mainSlider,
        on: {
            pageAfterIn(e, page) {
                page.router.clearPreviousHistory();
            },
        },
    },
//    {
//        path: '/otp_varification/',
//        component: otp_varification,
//    },
    {
        path: '/about/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var url = app.data.remoteUrl + 'content/about';
            console.log(url);
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                resolve(
                        {
                            component: AboutPage,
                        },
                        {
                            context: {
                                data: data.data,
                            }
                        }
                );

            });
        },
    },
    {
        path: '/edit_profile/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'user/profile';
            console.log(url);
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    // Keep cached avatar in sync so the side panel reflects
                    // server state (e.g. if avatar was changed on another device).
                    var av = (data.data && data.data.avatar_url) || '';
                    if (av) {
                        localStorage.setItem('avatar_url', av);
                    } else {
                        localStorage.removeItem('avatar_url');
                    }
                    app.data.user.avatar = av;
                    resolve(
                            {
                                component: edit_profile,
                            },
                            {
                                context: {
                                    data: data.data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });
                }

            });
        },
    },
    {
        path: '/form/',
        component: FormPage,
    },

    {
        path: '/doctors/:dep/:dep_name/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var dep = routeTo.params.dep;
            var city = localStorage.getItem('city');
            var url = app.data.remoteUrl + 'doctors?department=' + dep + '&city=' + city + '&page=1&per_page=10';
            app.request.json(url, function (data) {
                app.preloader.hide();
                var list = (data && data.data) ? data.data : (data || []);
                var meta = (data && data.meta) ? data.meta : { has_more: false, current_page: 1, total: list.length };
                resolve(
                        {
                            component: DoctorsDepFilter,
                        },
                        {
                            context: {
                                assetsUrl: app.data.assetsUrl,
                                data: list,
                                hasMore: !!meta.has_more,
                                currentPage: meta.current_page || 1,
                                perPage: meta.per_page || 10,
                                total: meta.total || list.length,
                                listEndpoint: 'doctors?department=' + dep + '&city=' + city,
                            }
                        }
                );

            });
        },
    },

    {
        path: '/hospital/:hospital/:hospital_name/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var hospital = routeTo.params.hospital;
            var city = localStorage.getItem('city');
            var url = app.data.remoteUrl + 'doctors?hospital=' + hospital + '&city=' + city + '&page=1&per_page=10';
            app.request.json(url, function (data) {
                app.preloader.hide();
                var list = (data && data.data) ? data.data : (data || []);
                var meta = (data && data.meta) ? data.meta : { has_more: false, current_page: 1, total: list.length };
                resolve(
                        {
                            component: DoctorsHosFilter,
                        },
                        {
                            context: {
                                assetsUrl: app.data.assetsUrl,
                                data: list,
                                hasMore: !!meta.has_more,
                                currentPage: meta.current_page || 1,
                                perPage: meta.per_page || 10,
                                total: meta.total || list.length,
                                listEndpoint: 'doctors?hospital=' + hospital + '&city=' + city,
                            }
                        }
                );

            });
        },
    },

    {
        path: '/search/',
        component: universalSearch,
    },
    {
        path: '/searchDoctor/',
        async: function (routeTo, routeFrom, resolve, reject) {
            loadInitialDoctors(this.app, '1', resolve);
        },
    },
    {
        path: '/searchDoctor/:type/',
        async: function (routeTo, routeFrom, resolve, reject) {
            loadInitialDoctors(this.app, routeTo.params.type, resolve);
        },
    },

    {
        path: '/booking/:doc/:type',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var doc = routeTo.params.doc;
            var type = routeTo.params.type;
            var pageId = 'booking_form'+ app.methods.pageid();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'doctors/' + doc + '/availability/' + type;
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                // Handle null/undefined response
                if (!data) {
                    app.dialog.alert("Failed to load doctor availability", "Error");
                    return;
                }
                var apiData = data.data || data || {};
                console.log(apiData);
                // Ensure doctor ID is available (from API or route param)
                if (!apiData.id) {
                    apiData.id = doc;
                }
                // Ensure dates and slot arrays exist with defaults
                if (!apiData.dates || !Array.isArray(apiData.dates)) {
                    apiData.dates = [];
                }
                // Handle slots - API may return 'slots' (array of objects) or 'slot' (array of strings)
                if (apiData.slots && Array.isArray(apiData.slots)) {
                    // Transform slot objects to display strings
                    apiData.slot = apiData.slots.map(function(s) {
                        return typeof s === 'object' ? (s.display || s.start_time + ' - ' + s.end_time) : s;
                    });
                } else if (!apiData.slot || !Array.isArray(apiData.slot)) {
                    apiData.slot = [];
                }
                // Ensure charge objects exist with defaults
                if (!apiData.charge) {
                    apiData.charge = { fee: 0, originalFee: 0, serviceCharge: 0, discountAmount: 0, gstAmount: 0, TotalCharge: 0 };
                }
                if (!apiData.chargeWithCoupon) {
                    apiData.chargeWithCoupon = { fee: 0, originalFee: 0, serviceCharge: 0, discountAmount: 0, gstAmount: 0, gstRate: 0, TotalCharge: 0 };
                }
                if (!apiData.coupon) {
                    apiData.coupon = { code: '', couponAmount: 0 };
                }
                // Extract default date and time from arrays
                var defaultDate = '';
                if (apiData.dates.length > 0) {
                    var firstDate = apiData.dates[0];
                    defaultDate = firstDate.fullDate || firstDate.full_date || firstDate.date || '';
                }
                var defaultTime = (apiData.slot.length > 0) ? apiData.slot[0] : '';
                resolve(
                        {
                            component: booking,
                        },
                        {
                            context: {
                                assetsUrl: app.data.assetsUrl,
                                data: apiData,
                                type: type,
                                pageId : pageId,
                                defaultDate: defaultDate,
                                defaultTime: defaultTime,
                                doctorId: doc
                            }
                        }
                );

            });
        },
    },
    {
        path: '/paymentSuccess/',
        component: paymentSuccess,
    },
    {
        path: '/appointment/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'bookings';
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: appointment,
                            },
                            {
                                context: {
                                    data: data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
        on: {
            pageAfterIn(e, page) {
                page.router.clearPreviousHistory();
            },
        },
    },
    {
        path: '/appointmentDetails/:appId',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var appId = routeTo.params.appId;
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'bookings/' + appId;
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: appointmentDetails,
                            },
                            {
                                context: {
                                    data: data.data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },

    {
        path: '/coupon/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'coupons';
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: coupon,
                            },
                            {
                                context: {
                                    data: data.data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },

    {
        path: '/applyCoupon/:doc/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var doc = routeTo.params.doc;
            var url = app.data.remoteUrl + 'coupons?doctor_id=' + doc;
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: applyCoupon,
                            },
                            {
                                context: {
                                    data: data.data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },

    {
        path: '/refer/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'user/referral';
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: refer,
                            },
                            {
                                context: {
                                    data: data.data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },

//    {
//        path: '/refer/',
//        component: refer,
//    },
    {
        path: '/support/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var app = this.app;

            // Reuse the same settings-driven enquiry data the home
            // "Get in touch" section uses. Prefer the warm home cache for
            // an instant render; fall back to the network; never block the
            // page if contact data is unavailable.
            var cached = app.methods.getCachedHome && app.methods.getCachedHome();
            if (cached && cached.enquiry) {
                resolve({ component: support }, { context: { enquiry: cached.enquiry } });
                return;
            }

            var city = localStorage.getItem('city');
            var url = app.data.remoteUrl + 'home?city=' + city;
            app.preloader.show();
            app.methods.authHeader();
            app.request({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    app.preloader.hide();
                    var apiData = (data && (data.data || data)) || {};
                    var enquiry = apiData.enquiry || null;
                    resolve({ component: support }, { context: { enquiry: enquiry } });
                },
                error: function () {
                    // Offline / failure — render with built-in fallbacks.
                    app.preloader.hide();
                    resolve({ component: support }, { context: { enquiry: null } });
                },
            });
        },
    },
    {
        path: '/query/',
        component: query,
    },

    {
        path: '/doctor_profile/',
        component: doctor_profile,
    },
    {
        path: '/notification/',
        component: notification,
    },
    {
        path: '/terms/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var url = app.data.remoteUrl + 'content/terms';
            console.log(url);
            app.request.json(url, function (data) {
                app.preloader.hide();
                resolve(
                        {
                            component: terms,
                        },
                        {
                            context: {
                                data: data.data,
                            }
                        }
                );

            });
        },
    },

    {
        path: '/terms1/',
        component: terms1,
    },

    {
        path: '/terms2/',
        component: terms2,
    },

    {
        path: '/subscription/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'subscription-plans';
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: subscrition,
                            },
                            {
                                context: {
                                    data: data.data,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },
    {
        path: '/subscription-single/:packages_id/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var packages_id = routeTo.params.packages_id;
            var url = app.data.remoteUrl + 'subscription-plans/' + packages_id;
            var pageId = app.methods.pageid();
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: subscrition,
                            },
                            {
                                context: {
                                    data: data.data,
                                    pageId: pageId
                                }
                            }
                    );
                }
            });
        },
    },
    {
        path: '/subscription-booking/:subspackage/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var pageId = 'subscription_form_'+ app.methods.pageid();
            var subspackage = routeTo.params.subspackage;
            var url = app.data.remoteUrl + 'subscriptions/' + subspackage + '/order';
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    resolve(
                            {
                                component: subscrition_paynow,
                            },
                            {
                                context: {
                                    data: data.data,
                                    pageId:pageId
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },

    {
        path: '/subscription-details/:subspackage/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var subspackage = routeTo.params.subspackage;
            var url = app.data.remoteUrl + 'subscriptions/' + subspackage;
            app.request.json(url, function (data) {
                console.log(data);
                app.preloader.hide();
                if (data.status) {
                    var apiData = data.data || {};
                    // Reshape to match template expectations
                    var contextData = {
                        subscriptions: {
                            status: apiData.status,
                            valid_from: apiData.valid_from,
                            valid_upto: apiData.valid_upto,
                            total_opd: apiData.total_opd,
                            unused_opd: apiData.unused_opd,
                            used_opd: apiData.used_opd
                        },
                        patientlist: apiData.patients || [],
                        package: apiData.package,
                        appointments: apiData.appointments || []
                    };
                    resolve(
                            {
                                component: subscrition_details,
                            },
                            {
                                context: {
                                    data: contextData,
                                }
                            }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({
                        component: mobileVerification,
                    });

                }

            });
        },
    },



    // All Categories page
    {
        path: '/all-categories/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'categories';
            app.request.json(url, function (data) {
                app.preloader.hide();
                resolve(
                    { component: allCategories },
                    { context: { assetsUrl: app.data.assetsUrl, data: data.data } }
                );
            });
        },
    },

    // All Specialities page
    {
        path: '/all-specialities/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var url = app.data.remoteUrl + 'departments';
            app.request.json(url, function (data) {
                app.preloader.hide();
                resolve(
                    { component: allSpecialities },
                    { context: { assetsUrl: app.data.assetsUrl, data: data.data } }
                );
            });
        },
    },

    // All Hospitals page
    {
        path: '/all-hospitals/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            var city = localStorage.getItem('city') || '';
            var base = 'hospitals?city=' + encodeURIComponent(city);
            var url = app.data.remoteUrl + base + '&page=1&per_page=10';
            app.request.json(url, function (data) {
                app.preloader.hide();
                // Paginated response: { status, data: { data: [], meta: {} } }
                var payload = (data && data.data) ? data.data : {};
                var list = (payload && payload.data) ? payload.data : (payload || []);
                var meta = (payload && payload.meta) ? payload.meta : { has_more: false, current_page: 1, total: list.length };
                resolve(
                    { component: allHospitals },
                    {
                        context: {
                            assetsUrl: app.data.assetsUrl,
                            data: list,
                            hasMore: !!meta.has_more,
                            currentPage: meta.current_page || 1,
                            perPage: meta.per_page || 10,
                            total: meta.total || list.length,
                            listEndpoint: base,
                        }
                    }
                );
            });
        },
    },

    // Path Lab listing page
    {
        path: '/pathlab/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var city = localStorage.getItem('city');
            var url = app.data.remoteUrl + 'pathology-labs?city=' + city;
            app.request.json(url, function (data) {
                app.preloader.hide();
                if (data.status) {
                    resolve(
                        { component: pathlab },
                        { context: { assetsUrl: app.data.assetsUrl, data: data.data } }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({ component: mobileVerification });
                }
            });
        },
    },

    // Path Lab Tests page
    {
        path: '/pathlab-tests/:labId/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var labId = routeTo.params.labId;
            var url = app.data.remoteUrl + 'pathology-labs/' + labId + '/tests';

            console.log('Pathlab Tests - URL:', url);
            console.log('Pathlab Tests - Lab ID:', labId);

            app.request.json(url, function (response) {
                app.preloader.hide();

                console.log('Pathlab Tests - API Response:', JSON.stringify(response, null, 2));

                if (response && response.status && response.data) {
                    console.log('Pathlab Tests - Lab:', response.data.lab);
                    console.log('Pathlab Tests - Tests count:', response.data.tests ? response.data.tests.length : 0);
                    console.log('Pathlab Tests - Patients count:', response.data.patients ? response.data.patients.length : 0);

                    resolve(
                        { component: pathlabTests },
                        {
                            context: {
                                lab: response.data.lab || { name: 'Path Lab' },
                                tests: response.data.tests || [],
                                patients: response.data.patients || []
                            }
                        }
                    );
                } else {
                    console.error('Pathlab Tests - API Error:', response);
                    if (!response || !response.status) {
                        app.dialog.alert('Unable to load lab tests. Please try again.', 'Error');
                    }
                    localStorage.setItem("token", "");
                    resolve({ component: mobileVerification });
                }
            }, function() {
                app.preloader.hide();
                console.error('Pathlab Tests - Request Failed');
                app.dialog.alert('Failed to load lab tests. Please check your connection.', 'Error');
                router.back();
            });
        },
    },

    // Lab Bookings listing page
    {
        path: '/lab-bookings/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'lab-bookings';
            app.request.json(url, function (data) {
                app.preloader.hide();
                if (data.status) {
                    resolve(
                        { component: labBookings },
                        { context: { data: data } }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({ component: mobileVerification });
                }
            }, function() {
                app.preloader.hide();
                app.dialog.alert('Failed to load lab bookings.', 'Error');
                router.back();
            });
        },
    },

    // Blood Bank page
    {
        path: '/blood-bank/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'blood-banks';
            app.request.json(url, function (data) {
                app.preloader.hide();
                if (data.status) {
                    resolve(
                        { component: bloodBank },
                        { context: { patients: data.patients, bloodGroups: data.bloodGroups, isActiveSubscription: data.isActiveSubscription, patientList: data.patientList } }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({ component: mobileVerification });
                }
            });
        },
    },

    // My Patients page
    {
        path: '/patients/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var url = app.data.remoteUrl + 'patients';
            app.request.json(url, function (data) {
                app.preloader.hide();
                if (data.status) {
                    resolve(
                        { component: patients },
                        { context: { data: data.data } }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({ component: mobileVerification });
                }
            });
        },
    },

    // IPD page
    {
        path: '/ipd/',
        async: function (routeTo, routeFrom, resolve, reject) {
            var router = this;
            var app = router.app;
            app.preloader.show();
            app.methods.authHeader();
            var city = localStorage.getItem('city') || '';
            var url = app.data.remoteUrl + 'ipd-bookings/form-data' + (city ? '?city=' + encodeURIComponent(city) : '');
            app.request.json(url, function (data) {
                app.preloader.hide();
                if (data.status) {
                    resolve(
                        { component: ipd },
                        { context: { patients: data.patients, hospitals: data.hospitals } }
                    );
                } else {
                    localStorage.setItem("token", "");
                    resolve({ component: mobileVerification });
                }
            });
        },
    },

    {
        path: '/dynamic-route/blog/:blogId/post/:postId/',
        component: DynamicRoutePage,
    },
    {
        path: '/request-and-load/user/:userId/',
        async: function (routeTo, routeFrom, resolve, reject) {
            // Router instance
            var router = this;

            // App instance
            var app = router.app;

            // Show Preloader
            app.preloader.show();

            // User ID from request
            var userId = routeTo.params.userId;

            // Simulate Ajax Request
            setTimeout(function () {
                // We got user data from request
                var user = {
                    firstName: 'Vladimir',
                    lastName: 'Kharlampidi',
                    about: 'Hello, i am creator of Framework7! Hope you like it!',
                    links: [
                        {
                            title: 'Framework7 Website',
                            url: 'http://framework7.io',
                        },
                        {
                            title: 'Framework7 Forum',
                            url: 'http://forum.framework7.io',
                        },
                    ]
                };
                // Hide Preloader
                app.preloader.hide();

                // Resolve route to load page
                resolve(
                        {
                            component: RequestAndLoad,
                        },
                        {
                            context: {
                                user: user,
                            }
                        }
                );
            }, 1000);
        },
    },
    {
        path: '(.*)',
        component: NotFoundPage,
    },
];

export default routes;